import {Injectable} from '@angular/core';
import {ConfigService} from "./config.service";

@Injectable({
  providedIn: 'root'
})
export class LegalService {

  culture: string = '';
  url: string = '';

  fileMapping : any = {
    'privacy-policy': 'connected-privacy-policy',
    'terms-service': 'connected-term-service',
    'terms-use': 'website-terms-use',
    'terms-sales': 'connected-terms-sales',
    'terms-conditions': 'connected-terms-conditions'
  }

  constructor(private configService: ConfigService) {
    this.culture = this.configService.getSelectedCulture();
    this.url = this.configService.getBackOfficeConfig().PRIVACY_POLICY_URL;
  }

  getLegalDocument(docType: string): string {
    if(!this.fileMapping[docType]) return 'ERROR: File not Found';
    const docFilename = this.fileMapping[docType];
    switch (process.env['BO_ENV']) {
      case 'local':
        return this.getURLforLocal(docFilename)
      case 'bucket':
        return this.getURLforRemote(docFilename)
      case 'backoffice':
        return this.getURLforRemote(docFilename)
      case 'backoffice-prod':
        return this.getURLforRemote(docFilename)
      default:
        return this.getURLforLocal(docFilename)
    }
  }


  private getURLforLocal(docFilename: string): string {
    return this.url + docFilename + '/' + this.culture;
  }

  private getURLforRemote(docFilename: string): string {
    return this.url + docFilename + '_' + this.culture + '.json';
  }

}
